import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, input, output } from '@angular/core';
import { Observable, tap } from 'rxjs';

import { ProductContextFacade } from 'ish-core/facades/product-context.facade';
import { ProductView } from 'ish-core/models/product-view/product-view.model';
import { LoadingComponent } from 'ish-shared/components/common/loading/loading.component';
import { ProductItemDisplayType } from 'ish-shared/components/product/product-item/product-item.component';

import { DotCmsUveProductTileComponent } from './dot-cms-uve-product-tile/dot-cms-uve-product-tile.component';

@Component({
  selector: 'custom-dot-cms-product-item',
  templateUrl: './dot-cms-uve-product-item.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AsyncPipe, DotCmsUveProductTileComponent, LoadingComponent],
})
export class DotCmsUveProductItemComponent implements OnInit {
  readonly isProductFailedEvent = output<boolean>(); // Declare an EventEmitter
  readonly displayType = input<ProductItemDisplayType>('tile');
  readonly layout = input<string>(undefined);
  readonly productElementUniqueId = input<string>(undefined);

  product$: Observable<ProductView>;
  loading$: Observable<boolean>;

  constructor(private context: ProductContextFacade) {}

  ngOnInit() {
    this.product$ = this.context.select('product');
    this.loading$ = this.context.select('loading');
    this.sendProductStatus();
  }

  sendProductStatus() {
    this.product$ = this.context.select('product').pipe(
      tap(data => {
        this.isProductFailedEvent.emit(data.failed);
      })
    );
  }

  get isTile() {
    return this.displayType() === 'tile';
  }

  get isRow() {
    return !this.isTile;
  }
}
